import type { PortfolioReport } from '@ovComponents/5-page/portfolioTradingHub/types';
import { useMemo } from 'react';
import { computeStagedTrades } from './computeStagedTrades';

export const useStagedTrades = (selectedPortfolios: PortfolioReport[]) => {
  const trades = useMemo(
    () => computeStagedTrades(selectedPortfolios),
    [selectedPortfolios],
  );

  return { trades };
};
